import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  public adminIn!: boolean;
  public viewType = 'userView';
  public jsnSourceShow!: boolean;
}
